// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__DkKzn","option":"styles_option__RZHqV","onTop":"styles_onTop__B4QTe","unassign":"styles_unassign__osEer","btn":"styles_btn__Lu6wF"};